import { withInstall } from '../utils/index';
import FormItem from './index.vue';
import './index.less';

export const TlbsFormItem = withInstall(FormItem);
export default TlbsFormItem;
